import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import { adhdDiagnosisConstants } from '../MemberAdhdDiagnosisStep';
import MemberAdhdInstructionsStep, {
	IMemberAdhdInstructionsStepPageContent,
} from './MemberAdhdInstructionsStep.component';

interface IMemberAdhdInstructionsStepPageProps extends IFlowStepProps {}

const MemberAdhdInstructionsStepPage: FC<IMemberAdhdInstructionsStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-adhd-instructions-step" }) {
				no_diagnosis_page_header
				no_diagnosis_page_info
				no_diagnosis_instructions_label
				no_diagnosis_instructions_link

				has_diagnosis_page_header
				has_diagnosis_page_info
				has_diagnosis_instructions_label
				has_diagnosis_instructions_link
				has_diagnosis_disclaimer
			}
		}
	`);

	const { existingFormData, handleNavNext } = useContext(FlowContext);

	const refinedContent: IMemberAdhdInstructionsStepPageContent = keysToCamel(
		pageContent
	) as IMemberAdhdInstructionsStepPageContent;

	const hasAdhdDiagnosis = existingFormData?.[adhdDiagnosisConstants.adhdDiagnosis] as
		| boolean
		| undefined;

	return (
		<MemberAdhdInstructionsStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleNavNext={handleNavNext}
			hasAdhdDiagnosis={hasAdhdDiagnosis}
		/>
	);
};

export default MemberAdhdInstructionsStepPage;
